import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleCustomsDeclarationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SingleCustomsDeclarationCreateDto,
  SingleCustomsDeclarationDto,
  SingleCustomsDeclarationExcelDownloadDto,
  SingleCustomsDeclarationUpdateDto,
} from '../proxy/controlling/dtos/single-customs-declaration';
import { SINGLECUSTOMSDECLARATION_CONFIG, SINGLECUSTOMSDECLARATION_FIELDS } from './single-customs-declaration.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-single-customs-declaration',
  imports: [
    CommonModule,
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, SingleCustomsDeclarationService, ConfirmationService],
  templateUrl: './single-customs-declaration.html',
  styleUrl: './single-customs-declaration.scss',
})
export class SingleCustomsDeclaration extends BaseHierarchicalCrudComponent<
  SingleCustomsDeclarationDto,
  SingleCustomsDeclarationCreateDto,
  SingleCustomsDeclarationUpdateDto,
  SingleCustomsDeclarationExcelDownloadDto
> {
  service = inject(SingleCustomsDeclarationService);
  config = SINGLECUSTOMSDECLARATION_CONFIG;
  fields = SINGLECUSTOMSDECLARATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: SingleCustomsDeclarationDto): SingleCustomsDeclarationUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SingleCustomsDeclaration';
  }
}
